import Vue from 'vue';
import App from './App';
import { router } from './router';
import 'amfe-flexible';

import './api'
// 限制最大font-size
import "@/utils/flexible";
import "@/utils";

new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
